import { PencilIcon } from 'lucide-react'
import { useState } from 'react'

import PartnersTeamMemberPanel from 'components/partners/PartnersTeamMemberPanel'
import type { PartnersPartnerAdmin } from 'utils/web_api.schemas'
import { useWindowLocation } from 'utils/windowLocation'

interface AdminPartnerAdminRolesProps {
  partnerAdmin: PartnersPartnerAdmin
  partnerId: string
}

export default function AdminPartnerAdminRoles ({ partnerAdmin, partnerId }: AdminPartnerAdminRolesProps) {
  const [isPanelOpen, setIsPanelOpen] = useState(false)
  const [currentTeamMember, setCurrentTeamMember] = useState(partnerAdmin)
  const { reload } = useWindowLocation()

  const handleOpenPanel = () => {
    setIsPanelOpen(true)
  }

  const handleClosePanel = () => {
    setIsPanelOpen(false)
  }

  const handleRemove = () => {
    reload()
  }

  const roles = currentTeamMember.roles.map(r => r.charAt(0).toUpperCase() + r.slice(1)).join(', ')
  const partnerships = currentTeamMember.carrier_partnerships ?? []
  const partnershipsText = partnerships.length > 0
    ? partnerships.map(p => p.display_name).join(', ')
    : null

  return (
    <div className='grid grid-cols-[1fr_1fr_4rem] items-center'>
      <div>
        {roles}
      </div>
      <div>
        {partnershipsText ?? <span className='text-gray-400'>None</span>}
      </div>
      <div className='text-center'>
        <button
          type='button'
          onClick={handleOpenPanel}
          className='inline-flex items-center justify-center text-indigo-600 hover:text-indigo-900 cursor-pointer'
          title='Edit team member'
        >
          <PencilIcon className='h-4 w-4' />
        </button>
      </div>

      <PartnersTeamMemberPanel
        teamMember={currentTeamMember}
        isOpen={isPanelOpen}
        onClose={handleClosePanel}
        onRemove={handleRemove}
        partnerId={partnerId}
        onTeamMemberUpdate={setCurrentTeamMember}
      />
    </div>
  )
}
